import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import axios from "axios"
import { toast } from "react-toastify"
import { addUserAuth } from "../redux/authSlice"

const setStore = ({ title, value }) => {
  localStorage.setItem(title, JSON.stringify(value))
}

const getStore = title => {
  // @ts-ignore
  const data = JSON.parse(localStorage?.getItem(title))
  return data
}

const getCookie = name => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const useLogin = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)


  const login = (form, e) => {
    e.preventDefault()
    setLoading(true)
    axios
      .post(`${process.env.REACT_APP_API_URL}login/`, { ...form })
      .then(res => {
        localStorage.setItem("auth", JSON.stringify(res.data))
        dispatch(addUserAuth(res.data))
        setLoading(false)
        window.location.href = "/"
      })
      .catch(err => {
        setLoading(false)
        const error = Object.values(err.response.data)[0]
        console.log(err.response.data)
        console.log(error.toString())
        toast.error(
          error
            .toString()
            .charAt(0)
            .toUpperCase() + error.toString().slice(1)
        )
      })
  }

  return { loading, login }
}

const useSignup = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const signup = (form, e) => {
    e.preventDefault()
    setLoading(true)
    axios
      .post(`${process.env.REACT_APP_API_URL}register/`, { ...form })
      .then(res => {
        console.log(res)
        localStorage.setItem("auth", JSON.stringify(res.data))
        dispatch(addUserAuth(res.data))
        toast.success(
          "Congratulations! You have successfully created your account"
        )
        setLoading(false)
        setTimeout(() => {
          window.location.href = "/"
        }, 4000)
      })
      .catch(err => {
      console.log(err)
        const error = Object.values(err.response.data)[0]
        toast.error(
          error
            .toString()
            .charAt(0)
            .toUpperCase() + error.toString().slice(1)
        )
        setLoading(false)
      })
  }

  return { loading, signup }
}

const logout = () => {
  localStorage.removeItem("auth")
  window.location.href = "/login"
}

const useDispatchAction = e => {
  const action = useDispatch()
  const dispatch = () => {
    action(e)
  }
  return dispatch
}

const auth = getStore("auth")

const usePost = ({ url, form }) => {
  const { user_id } = useSelector(state => state.user.auth)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  const { fetch } = useGet(url.includes("zone") ? "zones/" : "bins/")

  const post = e => {
    e.preventDefault()

    setLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_API_URL + url}`,
        { ...form, user: user_id },
        {
          headers: {
            Authorization: `Token ${auth.token}`,
            'X-CSRFToken': getCookie('csrftoken')
          }
        }
      )
      .then(res => {
        // fetch()
        console.log(res.data)
        setData(res.data)
        fetch()
        toast.success(
          `New ${url.includes("zone") ? "zone" : "bin"} "${
            res.data.name
          }" has been created! 🎉`
        )
        setLoading(false)
      })
      .catch(err => {
        if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(err.response.data);
          console.log(err.response.status);
          console.log(err.response.headers);
          toast.error(`Error: ${err.response.data.detail}`);
        } else if (err.request) {
          // The request was made but no response was received
          console.log(err.request);
          toast.error('Error: No response from the server.');
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', err.message);
          toast.error(`Error: ${err.message}`);
        }
        setLoading(false)
      })
  }


  const postMultipleBins = (e, bin = form) => {
    e && e.preventDefault();
  
    setLoading(true);
  
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_API_URL + url}`,
          { ...bin, user: user_id },
          {
            headers: {
              Authorization: `Token ${auth.token}`,
              'X-CSRFToken': getCookie('csrftoken')
            }
          }
        )
        .then(res => {
          fetch();
          console.log(res.data);
          setData(res.data);
          fetch();
          toast.success(
            `New ${url.includes("zone") ? "zone" : "bin"} "${
              res.data.name
            }" has been created! 🎉`
          );
          setLoading(false);
  
          resolve(res.data);
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
          
          if (err.response) {
            if (err.response.status === 400) {
              toast.error('Error: Invalid data. Please check the input fields.');
            } else if (err.response.status === 500) {
              toast.error('Error: Server error. Please try again later.');
            } else {
              toast.error(`Error: ${err.response.data.detail}`);
            }
          } else if (err.request) {
            toast.error('Error: No response from the server.');
          } else {
            toast.error(`Error: ${err.message}`);
          }
          
          reject(err);
        });
    });
  };
  

  return { loading, data, post, postMultipleBins }
}


const useGet = url => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const fetch = () => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API_URL + url}`, {
        headers: {
          Authorization: `Token ${auth?.token}`,
          'X-CSRFToken': getCookie('csrftoken')
        }
      })
      .then(res => {
        console.log('Response data:', res.data) 
        // const jo = res.data;
        // if (url.includes("zones")) {
        //   dispatch(addZones(res.data));
        // }
        setData(res.data)
        setLoading(false)
      })
      .catch(err => {
        console.log('Error:', err)
      })
  }
  {
  }

  return { isLoading: loading, fetchedData: data, fetch }
}

const useDelete = () => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])

  const deleteItem = ({ url, id, data }) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL + url}`, {
        headers: {
          Authorization: `Token ${auth.token}`,
          'X-CSRFToken': getCookie('csrftoken')
        }
      })
      .then(res => {
        const { name } = data.find(item => item.id === id)
        const items = data.filter(item => item.id !== id)
        setData(items)
        toast.success(`You have successfully deleted  "${name} 🎉"`)
      })
      .catch(err => {
        console.log(err)
      })
  }

  return { deleteItem, data }
}

const usePut = () => {
  const [loading, setLoading] = useState("")
  const [data, setData] = useState([])
  const { user_id } = useSelector(state => state.user.auth)

  const modify = ({ url, form, data }) => {
    setLoading("pending")
    axios
      .put(
        `${process.env.REACT_APP_API_URL + url}`,
        { ...form, user: user_id },
        {
          headers: {
            Authorization: `Token ${auth.token}`,
            'X-CSRFToken': getCookie('csrftoken')
          }
        }
      )
      .then(res => {
        const target = data.findIndex(
          obj => obj.id === Number(url?.match(/\d/g)?.join(""))
        )
        const newData = [...data]
        newData[target] = res.data
        console.log(newData)

        setData(newData)
        toast.success(`You have successfully modified "${res.data.name}" 🎉`)
        setLoading("success")
      })
      .catch(err => {
        if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(err.response.data);
          console.log(err.response.status);
          console.log(err.response.headers);
          setLoading("error");
          toast.error(`Error: ${err.response.data.detail}`);
        } else if (err.request) {
          // The request was made but no response was received
          console.log(err.request);
          toast.error('Error: No response from the server.');
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', err.message);
          toast.error(`Error: ${err.message}`);
        }
      })
  }

  return { loading, modify, modifyData: data }
}


export {
  setStore,
  getStore,
  getCookie,
  useLogin,
  useSignup,
  logout,
  useDispatchAction,
  usePost,
  useGet,
  useDelete,
  usePut
}
